export const tokens = {
    link: {
        gap: 6,
        fontSize: 14,
    },
    action: {
        gap: 10,
        padding: 10,
        height: 32,
        fontSize: 14,
    },
    content: {
        gap: 20,
        titleSize: 24,
        subtitleSize: 14,
    },
};
